import { Avatar, Box, Button, Grid, IconButton, Paper, Stack, styled, Typography, useMediaQuery, useTheme } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import Header from '../Header';
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";
import img2 from '../../assets/shop/Banner2.png';
import SwipeableViews from "react-swipeable-views";
import bgImage from "../../assets/shop/col-arrow.png";
import CategoryMenu from './CategoryMenu';
import RecentlyPurchased from './RecentlyPurchased';
import Meditation from './Meditation';
import Trataka from './Trataka';
import HappyFarmers from './HappyFarmers';
import Footer from '../Footer';
import ProductGrid from './ProductGrid';
import GetInTouch from './GetInTouch';
import Testimonials from './Testimonials';
import { motion } from "framer-motion";
import LocalFloristIcon from "@mui/icons-material/LocalFlorist";

const slides = [
    {
        desktop: img2,
        mobile:
            "https://www.anveshan.farm/cdn/shop/files/NEW_MOBILE_SIZE_4.webp?v=1751480946",
    },
    
];

// Styled Box for the full-width container
const FullWidthContainer = styled(Box)(({ theme }) => ({
    width: "100%",
    padding: theme.spacing(4, 0),
    display: "flex",
    justifyContent: "center",
}));

// Styled Paper for the content card - Updated to match Courses theme
const ContentCard = styled(Paper)(({ theme }) => ({
    backgroundColor: "#fff",
    padding: theme.spacing(5),
    borderRadius: theme.shape.borderRadius * 2,
    boxShadow: "0px 4px 15px rgba(109, 22, 117, 0.1)",
    width: "90%",
    maxWidth: "1200px",
    position: "relative",
    zIndex: 1,
    textAlign: "center",
    "&::before": {
        content: '""',
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        opacity: 0.05,
        borderRadius: theme.shape.borderRadius * 2,
        zIndex: -1,
    },
}));

// Styled Typography for titles - Updated to match Courses theme
const Title = styled(Typography)(({ theme }) => ({
    color: "#6d1675",
    fontWeight: "bold",
    marginBottom: theme.spacing(1),
    fontSize: "30px",
}));

// Styled Typography for body text - Updated to match Courses theme
const Description = styled(Typography)(({ theme }) => ({
    color: "#666",
    marginBottom: theme.spacing(3),
    lineHeight: 1.6,
    fontSize: "15px",
    fontWeight: "500",
}));

// Styled Buttons - Updated to match Courses theme
const ActionButton = styled(Button)(({ theme }) => ({
    marginTop: theme.spacing(2),
    padding: "12px 30px",
    borderRadius: "50px",
    fontWeight: "bold",
    textTransform: "none",
    fontSize: "16px",
    "&:first-of-type": {
        backgroundColor: "#ffc20f",
        color: "#000",
        "&:hover": {
            backgroundColor: "#6d1675",
            color: "#fff",
        },
        marginRight: theme.spacing(2),
    },
    "&:last-of-type": {
        backgroundColor: "transparent",
        border: "2px solid #6d1675",
        color: "#6d1675",
        "&:hover": {
            backgroundColor: "#6d1675",
            color: "#fff",
        },
    },
}));

// Flower divider component to match Courses theme
const FlowerDivider = ({ maxWidth = 300 }) => (
    <Box
        sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            maxWidth,
            mx: "auto",
            my: 2,
        }}
    >
        <Box sx={{ flex: 1, height: 3, bgcolor: "#6d1675" }} />
        <Box
            sx={{
                px: 2,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}
        >
            <LocalFloristIcon sx={{ fontSize: 28, color: "#ffc20f" }} />
        </Box>
        <Box sx={{ flex: 1, height: 3, bgcolor: "#6d1675" }} />
    </Box>
);

const Shop = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const [index, setIndex] = useState(0);
    const [cartItems, setCartItems] = useState([]);
    const [activeCategory, setActiveCategory] = useState("All");

    useEffect(() => {
        const storedCart = sessionStorage.getItem('cart');
        if (storedCart) {
            setCartItems(JSON.parse(storedCart));
        }
    }, []);

    const handleNext = () => {
        setIndex((prev) => (prev + 1) % slides.length);
    };

    const handlePrev = () => {
        setIndex((prev) => (prev - 1 + slides.length) % slides.length);
    };

    useEffect(() => {
        const interval = setInterval(() => {
            setIndex((prev) => (prev + 1) % slides.length);
        }, 5000);
        return () => clearInterval(interval);
    }, []);

    // Animation variants to match Courses component
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: { staggerChildren: 0.3 },
        },
    };

    const itemVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: { opacity: 1, y: 0 },
    };

    return (
        <Grid sx={{ overflow: "hidden" }}>
            <Header />
            <Box sx={{ position: "relative", overflow: "hidden", mt: 10 }}>
                <SwipeableViews index={index} onChangeIndex={setIndex} enableMouseEvents>
                    {slides.map((slide, i) => (
                        <a
                            key={i}
                            // href={slide.link}
                            style={{ display: "block", width: "100%" }}
                        >
                            <picture>
                                <source media="(min-width:960px)" srcSet={slide.desktop} />
                                <img
                                    src={slide.mobile}
                                    alt=""
                                    loading="eager"
                                    style={{ width: "100%", height: "auto", display: "block" }}
                                />
                            </picture>
                        </a>
                    ))}
                </SwipeableViews>

                {/* Arrows */}
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: 0,
                        transform: "translateY(-50%)",
                        zIndex: 10,
                    }}
                >
                    <IconButton 
                        onClick={handlePrev} 
                        sx={{ 
                            color: "white",
                            backgroundColor: "rgba(109, 22, 117, 0.7)",
                            "&:hover": { backgroundColor: "#6d1675" },
                            mx: 1
                        }}
                    >
                        <ArrowBackIos />
                    </IconButton>
                </Box>
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        right: 0,
                        transform: "translateY(-50%)",
                        zIndex: 10,
                    }}
                >
                    <IconButton 
                        onClick={handleNext} 
                        sx={{ 
                            color: "white",
                            backgroundColor: "rgba(109, 22, 117, 0.7)",
                            "&:hover": { backgroundColor: "#6d1675" },
                            mx: 1
                        }}
                    >
                        <ArrowForwardIos />
                    </IconButton>
                </Box>

                {/* Dots */}
                <Box
                    sx={{
                        position: "absolute",
                        bottom: 16,
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        gap: 1,
                    }}
                >
                    {slides.map((_, i) => (
                        <Box
                            key={i}
                            onClick={() => setIndex(i)}
                            sx={{
                                width: 12,
                                height: 12,
                                borderRadius: "50%",
                                backgroundColor: i === index ? "#ffc20f" : "rgba(255,255,255,0.5)",
                                cursor: "pointer",
                                border: i === index ? "2px solid #6d1675" : "none",
                            }}
                        />
                    ))}
                </Box>
            </Box>

            <Box
                component={motion.div}
                variants={containerVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false, amount: 0.2 }}
            >
                <FullWidthContainer>
                    <ContentCard>
                        <motion.div variants={itemVariants}>
                            <Title variant={isMobile ? "h5" : "h4"}>
                                Welcome to <span style={{ color: "#ffc20f" }}>Jyotish Jiggyasa</span>: Your Quest for Astrological Wisdom
                            </Title>
                        </motion.div>
                        
                        <FlowerDivider />
                        
                        <motion.div variants={itemVariants}>
                            <Description variant="body1">
                                Unlock the secrets of the cosmos with Jyotish Jigyasa, where ancient
                                astrological wisdom meets modern understanding. We offer personalized
                                horoscope readings, detailed astrological reports, and insightful
                                consultations to guide you through life's journey. Our mission is to
                                provide clarity and direction by illuminating the path shown by the stars,
                                helping you navigate your future with confidence.
                            </Description>
                        </motion.div>
                        
                        <motion.div variants={itemVariants}>
                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    flexDirection: isMobile ? "column" : "row",
                                }}
                            >
                                <ActionButton
                                    variant="contained"
                                    sx={isMobile && { mb: 1, mr: 0 }}
                                >
                                    Get Your Horoscope
                                </ActionButton>
                                <ActionButton variant="outlined">
                                    Book a Consultation
                                </ActionButton>
                            </Box>
                        </motion.div>
                    </ContentCard>
                </FullWidthContainer>
            </Box>

            <Box
                component={motion.div}
                variants={containerVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false, amount: 0.2 }}
            >
                <CategoryMenu onSelectCategory={(category) => setActiveCategory(category)} />
            </Box>

            <Box
                component={motion.div}
                variants={containerVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false, amount: 0.2 }}
            >
                <RecentlyPurchased onCartUpdate={(updatedCart) => setCartItems(updatedCart)} filterCategory={activeCategory} />
            </Box>

            <Box
                component={motion.div}
                variants={containerVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false, amount: 0.2 }}
            >
                <Meditation />
            </Box>

            <Box
                component={motion.div}
                variants={containerVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false, amount: 0.2 }}
            >
                <Trataka />
            </Box>

            <Box
                component={motion.div}
                variants={containerVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false, amount: 0.2 }}
            >
                <HappyFarmers />
            </Box>

            <Box
                component={motion.div}
                variants={containerVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false, amount: 0.2 }}
            >
                <ProductGrid onCartUpdate={(updatedCart) => setCartItems(updatedCart)} />
            </Box>

            <Box
                component={motion.div}
                variants={containerVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false, amount: 0.2 }}
            >
                <GetInTouch />
            </Box>

            <Box
                component={motion.div}
                variants={containerVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false, amount: 0.2 }}
            >
                <Testimonials />
            </Box>

            <Footer />
        </Grid>
    )
}

export default Shop